import { NgModule, Pipe, PipeTransform } from "@angular/core";

import { GridFilter, GridFilterGroup } from "@hermes/states/grid-filters-state";
import {
    SanitizePipe,
    SanitizePipeModule,
} from "@hermes/utils-generic/pipes/sanitize";

@Pipe({
    name: "gridFilterIdSetter",
})
export class GridFilterIdSetterPipe implements PipeTransform {
    constructor(private apolloSantize: SanitizePipe) {}

    public transform(filter: GridFilter, filterGroup: GridFilterGroup): string {
        const id = `${filterGroup.presentation.toLowerCase()}-${
            filterGroup.name
        }-${filter.name}`;

        return this.apolloSantize.transform(id);
    }
}

@NgModule({
    declarations: [GridFilterIdSetterPipe],
    providers: [GridFilterIdSetterPipe],
    imports: [SanitizePipeModule],
    exports: [GridFilterIdSetterPipe],
})
export class GridFilterIdSetterPipeModule {}
